/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const es_cards_spending_default_description = /** @type {(inputs: {}) => string} */ () => {
	return `Todos los comercios aceptados. Balance único.`
};

const en_cards_spending_default_description = /** @type {(inputs: {}) => string} */ () => {
	return `All merchants accepted. Single balance pool.`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const cards_spending_default_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.cards_spending_default_description(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("cards_spending_default_description", locale)
	if (locale === "es") return es_cards_spending_default_description(inputs)
	return en_cards_spending_default_description(inputs)
};
export { cards_spending_default_description as "cards.spending.default_description" }